import { render } from "./CompareIntegrationsTable.vue?vue&type=template&id=425e8b5a&scoped=true"
import script from "./CompareIntegrationsTable.vue?vue&type=script&lang=js"
export * from "./CompareIntegrationsTable.vue?vue&type=script&lang=js"

import "./CompareIntegrationsTable.vue?vue&type=style&index=0&id=425e8b5a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425e8b5a"]])

export default __exports__